import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { cn } from '../../lib/utils';
interface MiniFAQProps {
  heading?: string;
  items: {
    q: string;
    a: string;
  }[];
}
export function MiniFAQ({
  heading = 'Common questions',
  items
}: MiniFAQProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-5 md:px-6 py-20 md:py-28 bg-surface" data-id="element-539">
      <div className="max-w-3xl mx-auto" data-id="element-540">
        <h2 className="font-serif text-3xl md:text-[2.6rem] text-ink leading-tight mb-10" data-id="element-541">
          {heading}
        </h2>
        <div className="space-y-3" data-id="element-542">
          {items.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="rounded-2xl border border-border bg-background overflow-hidden" data-id="element-543">
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-inset" data-id="element-544">
                  <span className="font-serif text-lg text-ink" data-id="element-545">{item.q}</span>
                  <Plus className={cn('w-5 h-5 text-accent shrink-0 transition-transform duration-300 ease-soft', isOpen && 'rotate-45')} data-id="element-546" />
                </button>
                <div className={cn('grid transition-all duration-300 ease-soft', isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0')} data-id="element-547">
                  <div className="overflow-hidden" data-id="element-548">
                    <p className="px-6 pb-5 text-muted-ink leading-relaxed" data-id="element-549">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}